<template>
    <div>
        <!-- Average -->
        <div class="flex flex-col">
            <h2 class="text-xl my-4 font-bold">Product reviews</h2>
            <div>
                <review-stars :score="reviews.score" class="mr-2" />
                <span
                    ><span class="font-bold">{{ reviews.score }}</span
                    >/5</span
                >
            </div>
            <span class="text-gray-600">Gemiddelde van {{ reviews.count }} {{ $t('beoordelingen') }}</span>
            <div class="my-4 space-y-1 text-sm">
                <div v-for="(bar, index) in Object.values(reviews.bars).reverse()" class="flex items-center">
                    <span class="w-20">{{ 5 - index }} sterren</span>
                    <div class="grow bg-gray-200 rounded-full h-2.5">
                        <div
                            class="bg-dgreen2 h-2.5 rounded-full"
                            :style="'width:' + (bar / reviews.count) * 100 + '%'"
                        ></div>
                    </div>
                    <span class="ml-4">{{ bar }}</span>
                </div>
            </div>
        </div>

        <div class="flex flex-col mb-4 reviews-pictures">
            <h3 class="my-4 font-bold">Afbeeldingen van klanten</h3>
            <div class="space-x-2">
                <Splide
                    :options="{
                        rewind: false,
                        perPage: 8,
                        gap: '0.3rem',
                        pagination: false,
                        arrows: reviews.images.length > 8,
                        fixedWidth: 80,
                        fixedHeight: 80,
                        breakpoints: {
                            640: {
                                perPage: 5,
                                arrows: reviews.images.length > 5,
                            },
                        },
                    }"
                    aria-label="Review pictures"
                >
                    <SplideSlide v-for="(image, index) in reviews.images">
                        <div class="h-[80px] w-[80px] hover:opacity-80 transition-all cursor-pointer">
                            <vue-picture
                                :image="image"
                                @click="showAllImages(image, index)"
                                :style="'w-full h-full object-cover rounded-lg'"
                            />
                        </div>
                    </SplideSlide>
                </Splide>
            </div>
        </div>

        <!-- Reviews -->
        <div class="space-y-3">
            <div
                v-for="review in reviewList"
                class="list-none p-4 rounded-lg bg-gray-50 border border-dgreen2/30 space-y-2"
            >
                <div class="flex items-center text-sm">
                    <review-stars :score="review.score" class="mr-2 text-sm" height="h-3" />
                    <span>{{ review.score }}/5</span>
                </div>
                <strong class="block">{{ review.title }}</strong>
                <p class="text-sm">{{ review.content }}</p>
                <div class="flex space-x-2">
                    <div
                        v-for="image in review.images"
                        class="h-20 w-20 hover:opacity-80 transition-all cursor-pointer"
                    >
                        <vue-picture
                            :image="image"
                            @click="showModal(image)"
                            :style="'w-full h-full object-cover rounded-lg'"
                        />
                    </div>
                </div>
                <div class="items-center flex text-gray-500 text-xs">
                    <span class="border-r inline-block border-gray-300 pr-2">{{ review.name }}</span
                    ><span class="pl-2">{{ review.created }}</span>
                </div>
            </div>
        </div>

        <div class="w-full flex relative" v-if="reviewList.length < reviews.count">
            <div class="absolute h-32 w-full bottom-0">
                <div class="w-full h-20 bg-linear-to-t from-white"></div>
                <div class="w-full h-12 bg-white"></div>
            </div>
            <button class="absolute bottom-0 left-1/2 -translate-x-1/2 button default" @click="loadMore">
                Toon Meer
            </button>
        </div>
    </div>

    <teleport to="#modals">
        <modal ref="imagesModal">
            <template v-slot:content>
                <Splide :options="mainOptions" ref="main" @splide:move="activeSlide" class="main-slide">
                    <SplideSlide v-for="image in reviews.images">
                        <img :src="image.origin_src" class="max-h-[1000px] mx-auto" />
                    </SplideSlide>
                </Splide>
            </template>
        </modal>
        <modal ref="imageModal">
            <template v-slot:content>
                <img :src="imageToModal.origin_src" class="max-h-[1000px] mx-auto" />
            </template>
        </modal>
    </teleport>
</template>

<script setup>
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { ref } from 'vue';

const props = defineProps({
    reviews: Object,
    slug: String,
});

const offset = ref(2);
const index = ref(0);
const main = ref();
const imageModal = ref();
const imagesModal = ref();
const imageToModal = ref(props.reviews.images.length ? props.reviews.images[0] : false);

const reviewList = ref(props.reviews.reviews);
const mainOptions = {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    gap: '1rem',
    pagination: false,
    start: index.value,
};

function activeSlide(_slide) {
    // console.log(slide.index);
}

function showModal(image) {
    // if (inBrowser) {
    // if ('ontouchstart' in document.documentElement) {
    // } else {
    imageToModal.value = image;
    imageModal.value.open = true;
    // }
    // }
}

function showAllImages(_image, idx) {
    // if (inBrowser) {
    // if ('ontouchstart' in document.documentElement) {
    // } else {
    mainOptions.start = idx;
    imagesModal.value.open = true;
    // }
    // }
}

function loadMore() {
    axios
        .get('/api/reviews/' + props.slug, {
            params: { offset: offset.value },
        })
        .then(function (response) {
            response.data.forEach((element) => {
                reviewList.value.push(element);
            });
            offset.value += 10;
        })
        .finally(function () {});
}

// function showLess(params) {

// }

// const reviewList = computed(() => {
//     return props.reviews.reviews;
// })
</script>
